import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './../css/Navbar.css';
import Resume from './../images/Resume.pdf';

class Navbar extends Component {
  openNav = () => {
    document.getElementById('mobileNav').style.width = '100%';
  };
  closeNav = () => {
    document.getElementById('mobileNav').style.width = '0%';
  };
  render() {
    return (
      <React.Fragment>
        <nav
          className="navbar navbar-expand-lg navbar-dark fixed-top"
          style={{ background: 'black' }}
        >
          <a className="navbar-brand resumelinkstyle" href={Resume} target="_self">
            LR
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" onClick={this.openNav}></span>
          </button>

          {/* Toggle Nav Start */}
          <div id="mobileNav" className="overlay">
            <span className="closebtn" onClick={this.closeNav}>
              &times;
            </span>
            <div className="overlay-content">
              <Link to="/" onClick={this.closeNav}>
                Home
              </Link>
              <Link to="/about" onClick={this.closeNav}>
                About
              </Link>
              <span className="connect">Connect via</span>
              <div className="social_icons_mobile">
                <a href="https://www.linkedin.com/in/likita-rai-09bb47199/">
                  {' '}
                  <i
                    className="fa fa-linkedin-square"
                    aria-hidden="true"
                    id="home__social-link"
                  ></i>
                </a>
                <a href="https://github.com/likitarai1">
                  {' '}
                  <i className="fa fa-github" aria-hidden="true" id="home__social-link"></i>
                </a>
                <a href="mailto:likitarai1@gmail.com">
                  {' '}
                  <i className="fa fa-envelope" aria-hidden="true" id="home__social-link"></i>
                </a>
              </div>
            </div>
          </div>
          {/* Toggle Nav End */}

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  Home
                </Link>{' '}
                <span className="sr-only">(current)</span>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <a href="mailto:likitarai1@gmail.com" className="nav-link">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}

export default Navbar;
